<template>
<div> <!-- root element start -->
  <div class="row">
    <div class="col-12">
      <div v-if="userLatestQuotesComp == 0" class="card border-0">
          <div class="card-body">

            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

          </div>
      </div>
      <div v-if="userLatestQuotesComp == 1" class="border-0 card px-2 mx-0 pt-0">
        <div class="row">
          <div class="col-12"><span class="h6 font-weight-bold ">Most Recent Quotes</span></div>
        </div>
        <div v-if="userLatestQuotes.length < 1" class="card-body border-0 mb-0 px-0 pt-0">

          <div class="row mt-2 mb-2">
            <div class="col-12 text-center"><h5 class="text-muted">No Current Quotes Found</h5></div>
          </div>

        </div>

        <div v-if="userLatestQuotes.length > 0" class="card-body border-0 mb-0 px-0 pt-0">

          <div v-for="(quote,index) in userLatestQuotes" class="card border-0 mb-1">
            <div class="card-body p-2">
              <div class="row">
                <div class="col-12 text-truncate">
                  <a :href="detailUrl + quote.id + '/1'" class="mr-2"><i class="fa fa-search" aria-hidden="true"></i></a>
                  <a :href="formUrl + quote.latest_form.id" target="_blank" class="mr-2"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
                  <small class="font-weight-bold ">{{ quote.org.org_title }}</small>

                </div>
              </div>
              <div class="row">
                <div class="col-12 text-truncate">
                  <small class="">{{ quote.build.product_name }}</small>, <small class="">{{ quote.created_at | moment("dddd, MMMM Do YYYY") }}</small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div> <!-- root element end -->
</template>

<style>
.vuetable :focus { outline:none; }
.vuetable thead { display: none; }
</style>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/user-dashboard-main-store.js'




export default {
  store,
  data: function () {
    return {
      formUrl: '/utility/quote/form/streamspecificform/',
      detailUrl: '/quote-builder/1/',

    }
  },
  computed: {
    userLatestQuotes() { return this.$store.state.userLatestQuotes; },
    userLatestQuotesComp() { return this.$store.state.userLatestQuotesComp; }
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },


    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },
  components:{
    ScalingSquaresSpinner,

  },
  filters: {

  }
}
</script>
